import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, TrendingUp, Award, Search, Mail, Download, MessageCircle, Calendar, Clock, ArrowRight, Zap, FileBarChart, Send, HelpCircle, CheckCircle, AlertCircle, Activity, Filter, ExternalLink, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function AdminHub() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [reminderLearner, setReminderLearner] = useState('');
  const [isReminderDropdownOpen, setIsReminderDropdownOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const reminderDropdownRef = useRef<HTMLDivElement>(null);
  const incompleteLearners = [{
    value: 'rachel-patel',
    name: 'Rachel Patel',
    email: 'rachel.patel@example.com'
  }, {
    value: 'david-nguyen',
    name: 'David Nguyen',
    email: 'd.nguyen@example.com'
  }, {
    value: 'karen-brooks',
    name: 'Karen Brooks',
    email: 'k.brooks@example.com'
  }, {
    value: 'marcus-hall',
    name: 'Marcus Hall',
    email: 'marcus.h@example.com'
  }, {
    value: 'tanya-foster',
    name: 'Tanya Foster',
    email: 'tanya.f@example.com'
  }];
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
      if (reminderDropdownRef.current && !reminderDropdownRef.current.contains(event.target as Node)) {
        setIsReminderDropdownOpen(false);
      }
    };
    if (isUserMenuOpen || isReminderDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen, isReminderDropdownOpen]);
  const navigationCards = [{
    title: 'Analytics Dashboard',
    description: 'View detailed performance metrics and insights',
    icon: BarChart3,
    color: 'from-[#00638C] to-[#30718D]',
    stats: '248 learners tracked',
    link: '/analytics'
  }, {
    title: 'User Management',
    description: 'Manage learner accounts and permissions',
    icon: UserCog,
    color: 'from-[#30718D] to-[#265a70]',
    stats: '18 pending invites',
    link: '/assessment'
  }, {
    title: 'Reports',
    description: 'Generate and download custom reports',
    icon: FileText,
    color: 'from-[#007558] to-[#005a44]',
    stats: 'Last report: 1 hour ago',
    link: '/feedback'
  }];
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-1118">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-1119">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1120">
          <div className="flex items-center h-16" data-id="element-1121">
            {/* Logo */}
            <div className="text-[#E53E3E] font-bold text-xl" data-id="element-1122">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-1123">
              <Link to="/admin" className="flex items-center gap-2 text-[#00638C] border-b-2 border-[#00638C] pb-[22px] pt-[22px] transition-colors text-sm font-medium" data-id="element-1124">
                <Home size={18} data-id="element-1125" />
                <span className="hidden sm:inline" data-id="element-1126">Admin Hub</span>
              </Link>
              <Link to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1127">
                <BarChart3 size={18} data-id="element-1128" />
                <span className="hidden sm:inline" data-id="element-1129">Analytics</span>
              </Link>
              <Link to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1130">
                <FileText size={18} data-id="element-1131" />
                <span className="hidden sm:inline" data-id="element-1132">Reports</span>
              </Link>
              <Link to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-1133">
                <UserCog size={18} data-id="element-1134" />
                <span className="hidden sm:inline" data-id="element-1135">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-1136">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1137">
                <Bell size={20} data-id="element-1138" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-1139"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-1140">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-1141">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-1142">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-1143">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-1144" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-1145">
                    <div className="py-2" data-id="element-1146">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1147">
                        <Users size={18} className="text-gray-600" data-id="element-1148" />
                        <span className="font-medium text-gray-900" data-id="element-1149">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1150">
                        <Home size={18} className="text-gray-600" data-id="element-1151" />
                        <span className="font-medium text-gray-900" data-id="element-1152">
                          Learner Hub
                        </span>
                      </button>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1153">
                        <UserCog size={18} className="text-gray-600" data-id="element-1154" />
                        <span className="font-medium text-gray-900" data-id="element-1155">
                          Admin Hub
                        </span>
                      </button>
                      <Link to="/settings" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1156">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-1157">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" data-id="element-1158"></path>
                          <circle cx="12" cy="12" r="3" data-id="element-1159"></circle>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-1160">
                          Settings
                        </span>
                      </Link>
                      <div className="border-t border-gray-200 my-2" data-id="element-1161"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-1162">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-1163">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-1164"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-1165"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-1166"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-1167">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1168">
        {/* Header */}
        <div className="mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-4" data-id="element-1169">
          <div data-id="element-1170">
            <div className="text-xs font-semibold uppercase tracking-wider text-[#30718D] mb-1" data-id="element-1171">
              Administrator
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1172">
              Welcome Back, Linda
            </h1>
          </div>
          <button className="text-[#DB3725] hover:text-[#c02f1f] font-medium text-sm transition-colors self-start sm:self-auto flex items-center gap-1.5" data-id="element-1173">
            <Mail size={14} data-id="element-1174" />
            Contact support
          </button>
        </div>

        {/* Company & Send Email Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-1175">
          {/* Company Info Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex flex-col" data-id="element-1176">
            <div className="flex items-center gap-3 mb-4" data-id="element-1177">
              <div className="w-8 h-8 rounded-lg bg-[#30718D]/10 flex items-center justify-center flex-shrink-0" data-id="element-1178">
                <Building2 size={16} className="text-[#30718D]" data-id="element-1179" />
              </div>
              <div data-id="element-1180">
                <div className="text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-1181">
                  Company Name
                </div>
                <div className="text-base font-semibold text-gray-900" data-id="element-1182">
                  Lorem Ipsum
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-gray-100" data-id="element-1183">
              <div className="flex items-center gap-3" data-id="element-1184">
                <div className="w-8 h-8 rounded-lg bg-[#007558]/10 flex items-center justify-center flex-shrink-0" data-id="element-1185">
                  <Users size={16} className="text-[#007558]" data-id="element-1186" />
                </div>
                <div data-id="element-1187">
                  <div className="text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-1188">
                    Registered Learners
                  </div>
                  <div className="text-base font-semibold text-gray-900" data-id="element-1189">
                    4 Learners
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-3" data-id="element-1190">
              <div className="flex items-center gap-3" data-id="element-1191">
                <div className="w-8 h-8 rounded-lg bg-[#DB3725]/10 flex items-center justify-center flex-shrink-0" data-id="element-1192">
                  <Clock size={16} className="text-[#DB3725]" data-id="element-1193" />
                </div>
                <div data-id="element-1194">
                  <div className="text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-1195">
                    Pending
                  </div>
                  <div className="text-base font-semibold text-gray-900" data-id="element-1196">
                    5 Learners
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Send Account Creation Email */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 lg:col-span-2" data-id="element-1197">
            <div className="flex items-center gap-3 mb-4" data-id="element-1198">
              <div className="w-10 h-10 rounded-lg bg-[#30718D]/10 flex items-center justify-center" data-id="element-1199">
                <Mail size={20} className="text-[#30718D]" data-id="element-1200" />
              </div>
              <div data-id="element-1201">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-1202">
                  Send Account Creation Email
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1203">
                  Remind learners to complete account setup.{' '}
                  <span className="font-semibold text-[#DB3725]" data-id="element-1204">
                    5 pending
                  </span>
                </p>
              </div>
            </div>

            <div className="flex gap-3 items-end" data-id="element-1205">
              <div className="relative flex-1" ref={reminderDropdownRef} data-id="element-1206">
                <button onClick={() => {
                setIsReminderDropdownOpen(!isReminderDropdownOpen);
              }} className="flex items-center gap-2 w-full px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-sm font-medium" data-id="element-1207">
                  <Users size={18} className="text-[#30718D]" data-id="element-1208" />
                  <span className="flex-1 text-left text-gray-700" data-id="element-1209">
                    {reminderLearner ? incompleteLearners.find(l => l.value === reminderLearner)?.name : 'All incomplete learners (5)'}
                  </span>
                  <ChevronDown size={16} className={`text-gray-400 transition-transform ${isReminderDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1210" />
                </button>

                {isReminderDropdownOpen && <div className="absolute top-full mt-2 left-0 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-80 overflow-y-auto" data-id="element-1211">
                    <button onClick={() => {
                  setReminderLearner('');
                  setIsReminderDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 text-sm ${reminderLearner === '' ? 'bg-[#30718D]/5 text-[#30718D] font-semibold' : 'text-gray-700'}`} data-id="element-1212">
                      All incomplete learners
                    </button>
                    {incompleteLearners.map(learner => <button key={learner.value} onClick={() => {
                  setReminderLearner(learner.value);
                  setIsReminderDropdownOpen(false);
                }} className={`w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 ${reminderLearner === learner.value ? 'bg-[#30718D]/5' : ''}`} data-id="element-1213">
                        <div className={`font-medium text-sm ${reminderLearner === learner.value ? 'text-[#30718D]' : 'text-gray-900'}`} data-id="element-1214">
                          {learner.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-1215">
                          {learner.email}
                        </div>
                      </button>)}
                  </div>}
              </div>
              <button className="px-4 py-2.5 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-1216">
                <Send size={16} data-id="element-1217" />
                Send
              </button>
            </div>
          </motion.div>
        </div>

        {/* Performance Snapshot */}
        <div className="mb-8" data-id="element-1218">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1219">
            Performance Snapshot
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1220">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col" data-id="element-1221">
              <div className="p-6 flex-1 flex flex-col" data-id="element-1222">
                <div className="mb-3 text-gray-700 leading-relaxed" data-id="element-1223">
                  <span className="text-4xl font-bold text-gray-900 mr-2 align-middle" data-id="element-1224">
                    55
                  </span>
                  <span className="align-middle text-sm" data-id="element-1225">
                    of your invited learners have
                    <br data-id="element-1226" />
                    completed registration
                  </span>
                </div>
                <div className="flex items-center gap-1.5 text-[#007558] text-sm font-medium" data-id="element-1227">
                  <span className="text-xs" data-id="element-1228">▲</span>
                  <span data-id="element-1229">16% vs 30 days ago</span>
                </div>
              </div>
              <div className="h-1.5 w-full bg-[#007558]" data-id="element-1230"></div>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col" data-id="element-1231">
              <div className="p-6 flex-1 flex flex-col" data-id="element-1232">
                <div className="mb-3 text-gray-700 leading-relaxed" data-id="element-1233">
                  <span className="text-4xl font-bold text-gray-900 mr-2 align-middle" data-id="element-1234">
                    80%
                  </span>
                  <span className="align-middle text-sm" data-id="element-1235">
                    of your learners have
                    <br data-id="element-1236" />
                    spent time learning this week
                  </span>
                </div>
                <div className="flex items-center gap-1.5 text-[#007558] text-sm font-medium" data-id="element-1237">
                  <span className="text-xs" data-id="element-1238">▲</span>
                  <span data-id="element-1239">20% vs 30 days ago</span>
                </div>
              </div>
              <div className="h-1.5 w-full bg-[#007558]" data-id="element-1240"></div>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col" data-id="element-1241">
              <div className="p-6 flex-1 flex flex-col" data-id="element-1242">
                <div className="mb-3 text-gray-700 leading-relaxed" data-id="element-1243">
                  <span className="text-4xl font-bold text-gray-900 mr-2 align-middle" data-id="element-1244">
                    10%
                  </span>
                  <span className="align-middle text-sm" data-id="element-1245">
                    of your learners have
                    <br data-id="element-1246" />
                    completed all skill modules
                  </span>
                </div>
                <div className="flex items-center gap-1.5 text-[#DB3725] text-sm font-medium" data-id="element-1247">
                  <span className="text-xs" data-id="element-1248">▼</span>
                  <span data-id="element-1249">20% vs 30 days ago</span>
                </div>
              </div>
              <div className="h-1.5 w-full bg-[#DB3725]" data-id="element-1250"></div>
            </motion.div>
          </div>
        </div>

        {/* Navigation Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-1251">
          {navigationCards.map((card, index) => {
          const Icon = card.icon;
          return <Link key={index} to={card.link} data-id="element-1252">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className="group bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer" data-id="element-1253">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${card.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`} data-id="element-1254">
                    <Icon size={24} className="text-white" data-id="element-1255" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#00638C] transition-colors" data-id="element-1256">
                    {card.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-1257">
                    {card.description}
                  </p>
                  <div className="flex items-center justify-between" data-id="element-1258">
                    <span className="text-xs font-medium text-gray-500" data-id="element-1259">
                      {card.stats}
                    </span>
                    <ArrowRight size={16} className="text-gray-400 group-hover:text-[#00638C] group-hover:translate-x-1 transition-all" data-id="element-1260" />
                  </div>
                </motion.div>
              </Link>;
        })}
        </div>

        {/* Contact Support - Full Width Horizontal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8
      }} className="bg-gradient-to-br from-[#30718D] to-[#265a70] rounded-xl p-6 shadow-lg text-white mb-8" data-id="element-1261">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-1262">
            <div className="flex items-center gap-4" data-id="element-1263">
              <div className="w-12 h-12 rounded-lg bg-white/15 backdrop-blur-sm flex items-center justify-center flex-shrink-0" data-id="element-1264">
                <HelpCircle size={24} className="text-white" data-id="element-1265" />
              </div>
              <div data-id="element-1266">
                <h3 className="text-xl font-bold mb-1" data-id="element-1267">Need Help?</h3>
                <p className="text-sm text-white/70 max-w-2xl" data-id="element-1268">
                  Our support team is available 24/7 to help you with any
                  questions or issues you may have.
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center md:items-end justify-center gap-3 w-full md:w-auto" data-id="element-1269">
              <button className="w-full md:w-auto px-6 py-3 bg-white text-[#30718D] rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 text-sm font-semibold shadow-sm" data-id="element-1270">
                <Mail size={16} data-id="element-1271" />
                Email Support
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}